var gql = require("@apollo/client").gql;

const REGION_REVIEWS_FILTERS_QUERY = gql`
	query RegionReviewsFilters($filter: String) {
		regionReviewsFilters(filter: $filter) {
			data {
				providers {
					id
					name
					translit_name
				}
				rating
				services {
					id
					name
				}
			}
		}
	}
`;

export default REGION_REVIEWS_FILTERS_QUERY;
